import { TIIndicatorPointModel } from "./ti-indicator-point.model";

export enum IndicatorColorType { One, UpDown, Gradient }
export interface IndicatorClassAndColor {
    className: string;
    color: string;
}

export class TIIndicatorDataModel {
    public name = '';
    public abbreviatedName = '';
    public chartAreaName = '';
    public color = '';
    public chartType = '';
    public colorType = IndicatorColorType.One;
    public points: Array<TIIndicatorPointModel> = [];
    public zones: Array<any> = [];
    public colors: Array<IndicatorClassAndColor> = [];
    public childIndicators: Array<TIIndicatorDataModel> = [];

    constructor(indicatorData: any) {
        this.name = indicatorData.name;
        this.abbreviatedName = indicatorData.abbreviatedName;
        this.chartAreaName = indicatorData.chartAreaName;
        this.color = indicatorData.color;
        this.colorType = indicatorData.colorType;
        this.castPoints(indicatorData.points);
        this.castChildIndicators(indicatorData.childIndicators);
    }

    public getClassName(): string {
        return this.name.split(' ').join('').replace(/[^\w\s]/gi, '').toLowerCase();
    }

    public getUpColorClassName(): string {
        return this.getClassName() + '_' + 'up-color';
    }

    public getDownColorClassName(): string {
        return this.getClassName() + '_' + 'down-color';
    }

    public needHighChartZone(type: string): boolean {
        this.chartType = type;
        if (type == 'line' || type == 'spline') {
            if (this.colorType == IndicatorColorType.Gradient || this.colorType == IndicatorColorType.UpDown) {
                return true;
            }
        }

        return false;
    }

    private castPoints(data: any) {
        if (!data?.length) {
            return;
        }

        for (let i = 0; i < data.length; i++) {
            const point = new TIIndicatorPointModel(data[i]);
            this.points.push(point);
        }
    }

    private castChildIndicators(data: any) {
        if (!data?.length) {
            return;
        }

        for (let i = 0; i < data.length; i++) {
            const childIndicator = new TIIndicatorDataModel(data[i]);
            this.childIndicators.push(childIndicator);
        }
    }
}